export default "__VITE_ASSET__BhYrFyVo__"